module.exports = __webpack_public_path__ + "img/task-m.b1003250.jpeg";